// extracted by mini-css-extract-plugin
module.exports = {"detail-name":"transfer_review_box__detail-name___1VHnH"};